export default "__VITE_ASSET__17512c3f__"